import React, { useState, useEffect, MutableRefObject } from "react";
import { Controller, useForm } from "react-hook-form";
import { stateList, cardBrandList, CAProvinces } from "../../../util/CommonLists";
import EFTDialog from "../EFTDialog";
import { DialogComponent } from "../../common/DialogComponent";
import { PATTERNS } from "../../../util/patterns";
import * as services from "../../../store/service";
import { Notification } from "../../common/Notification";
import parse from "html-react-parser";
import BillingSecurityNote from "../../../components/Registration/Billing/BillingSecurityNote";
import PhoneInput from "react-phone-number-input";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { isValidPhoneNo } from "../../../util/phoneNumberValidationUtil";
import { validateCardExpiry } from "../../../util/common";
import { useTranslation } from "react-i18next";
import i18nService from "../../../util/Internationalization/i18n/i18n";

interface IProps {
    closeDialog: any;
    dialogId: string;
    setBillingInfoChanged: any;
    getSubscriptionType?: any;
    selectedPackage?: any;
}

const ProtectionPlanBillingInfo: React.FunctionComponent<IProps> = (props) => {
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const { t: tLang } = useTranslation();

    const [selectedPaymentOption, setSelectedPaymentOption] = useState("CC");
    const [billingText, setBillingText] = useState("");
    const [EFTdialog, setEFTDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [billingOperation, setBillingOperation] = useState("");
    const [state, setState] = useState({
        EFTData: [],
        paymentMethod: "Credit",
        isEFTChecked: false,
    });
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const [zipCode, setZipCode] = useState(i18nService.get("ZipCode"));
    const [bankInfoState, setBankInfoState] = useState({
        accountType: {
            options: [],
            selection: "",
            readOnly: true,
        },
        nameOnAccount: "",
        routingNumber: {
            options: [],
            selection: "",
            readOnly: true,
        },
        accountNumber: "",
        bankName: {
            options: [],
            selection: "",
            readOnly: true,
        },
    });

    const [cardInfoState, setCardInfoState] = useState({
        cardType: {
            options: [],
            selection: "",
            readOnly: true,
        },
        nameOnCard: "",
        cardNumber: "",
        expDateMo: "",
        expDateYr: "",
        securityCode: "",
    });

    const [addressState, setAddressState] = useState({
        address1: "",
        address2: "",
        city: "",
        state: {
            options: [],
            selection: "",
            readOnly: true,
        },
        zipCode: "",
        phone: "",
        country: "",
    });

    const [paymentModeState, setPaymentModeState] = useState({
        options: [],
        selection: "",
        name: "",
        subscriptionType: "",
    });

    const { register, handleSubmit, errors, setValue, setError, clearErrors, control, watch } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    let phoneInputRef: MutableRefObject<HTMLInputElement> | null = null;

    const RefreshAndClose = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const formatePhoneNumber = (phoneNumber: string) => {
        let phoneNumberWithoutMasking = phoneNumber;
        phoneNumberWithoutMasking = phoneNumberWithoutMasking.replace(" ", "");
        phoneNumberWithoutMasking = phoneNumberWithoutMasking.replace("(", "");
        phoneNumberWithoutMasking = phoneNumberWithoutMasking.replace(")", "");
        phoneNumberWithoutMasking = phoneNumberWithoutMasking.replace("-", "");
        return phoneNumberWithoutMasking;
    };

    const submitBillingInfo = (data: any) => {
        let packagePrice = "";
        let NewSMBLicenseLimit = "";
        if (props.getSubscriptionType() === "ONETIME") {
            packagePrice = props.selectedPackage?.Price;
        } else {
            packagePrice = props.getSubscriptionType() === "YEARLY" ? props.selectedPackage?.PackagePriceYearly : props.selectedPackage?.PackagePrice;
            if (props.selectedPackage && props.selectedPackage.Featurevalue) {
                NewSMBLicenseLimit = props.selectedPackage.Featurevalue;
            }
        }
        const reqBody = {
            packagePrice: packagePrice,
            packageCode: props.getSubscriptionType() === "ONETIME" ? props.selectedPackage?.Servicode : props.selectedPackage?.PackageCode,
            subscriptionType: props.getSubscriptionType(),
            country: addressState.country || "US",
            region: addressState.city,
            EnrollmentType: null,
            changeType: "",
            street1: addressState.address1,
            street2: addressState.address2,
            city: addressState.city,
            postalCode: addressState.zipCode,
            NewSMBLicenseLimit: NewSMBLicenseLimit,
        };
        if (props.dialogId === "pay-as-you-go-billing-information-dialog" || props.dialogId === "purchase-credit-report-billing-information-dialog") {
            SaveBillingInfo();
        } else {
            setLoading(true);
            services.getAvalaraService().then(() => {
                services
                    .getUpgradePackageAmountDetails(reqBody)
                    .then((res) => {
                        setLoading(false);
                        if (!res.isSuccess && res.errors[0] === "Bad Request") {
                            setError("billingAddress", { message: "Invalid Billing Address" });
                            let elem = document.getElementById("billing-info-dialog");
                            if (elem) {
                                elem.scrollTop = 1000000;
                            }
                        } else {
                            clearErrors("billingAddress");
                            SaveBillingInfo();
                        }
                    })
                    .catch(() => {
                        setLoading(false);
                        Notification({
                            type: "error",
                            title: tLang("manageAccount.protectionPlan.notification.packageDetails"),
                            message: tLang("manageAccount.protectionPlan.notification.couldNotGetPackageDetailInfoMsg"),
                        });
                    });
            });
        }
        // manageState(updateState(states, displayData.billingRequired, 3));
    };

    const SaveBillingInfo = () => {
        const requestBody = {
            creditCardDetails: selectedPaymentOption === "CC" ? cardInfoState : null,
            eftDetails: selectedPaymentOption === "EFT" ? bankInfoState : null,
            billingAddress: addressState,
            paymentMode: {
                Selection: selectedPaymentOption,
            },
            inAppDetails: null,
        };
        try {
            requestBody.billingAddress.phone = watch("phoneNumber");
        } catch { }
        setLoading(true);
        services
            .SaveBillingInfo(requestBody)
            .then((data) => {
                setLoading(false);
                if (data.isSuccess) {
                    props.setBillingInfoChanged(true);
                    props.closeDialog();
                } else if (data.errors && data.errors.length > 0) {
                    Notification({
                        type: "error",
                        title: tLang("manageAccount.protectionPlan.notification.title"),
                        message: data.errors[0],
                        duration: 5,
                    });
                } else {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: tLang("manageAccount.protectionPlan.notification.title"),
                        message: tLang("manageAccount.protectionPlan.notification.couldNotSaveInformationMsg"),
                        duration: 5,
                    });
                }
            })
            .catch(() => {
                setLoading(false);
                Notification({
                    type: "error",
                    title: tLang("manageAccount.protectionPlan.notification.title"),
                    message: tLang("manageAccount.protectionPlan.notification.couldNotSaveInformationMsg"),
                });
            });
    };

    const handlePaymentMethodChange = (changeEvent: any) => {
        setSelectedPaymentOption(changeEvent.target.value);
        // props.radioChanged(changeEvent.target.id, "0");
    };
    const handleCloseEFTDialog = (): any => {
        setEFTDialog(false);
    };
    const checked = () => {
        if (state.isEFTChecked) {
            //  state.isEFTChecked=false;
            setState({ ...state, isEFTChecked: false });
            return;
        }
        setState({ ...state, isEFTChecked: true });
    };

    let keyPressed: number;
    const keyCode = (e: any) => {
        keyPressed = e.keyCode;
    };
    const addMask = (e: any) => {
        e.preventDefault();
        if (e.target.value.length === 2 && keyPressed !== 8 && keyPressed !== 46) {
            e.target.value = e.target.value + "/";
        }
        setCardExpDate(e.target.value);
    };

    const setCardExpDate = (expDate: string) => {
        expDate = expDate.replace("/", "");
        setCardInfoState({ ...cardInfoState, expDateMo: expDate.substring(0, 2), expDateYr: expDate.substring(2, 4) });
    };

    const isDisplayableSection = (paymentMethod: string) => {
        let foundItem = paymentModeState.options?.find((it: string) => it.toUpperCase() === paymentMethod);
        return foundItem ? true : false;
    };

    const updatePhoneNumber = (e: any) => {
        setAddressState({ ...addressState, phone: formatePhoneNumber(e.target.value) });
    };

    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");

        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => { });
        };
    });
    useEffect(() => {
        setLoading(true);
        services.getEFTInfo().then((data: any) => {
            setState({ ...state, EFTData: data });
        });

        services.GetPaymentDetail().then((data) => {
            setLoading(false);
            setSelectedPaymentOption(data.paymentMethod.selection);

            if (data.creditCard) {
                const creditCard = data.creditCard;
                setCardInfoState({
                    ...cardInfoState,
                    cardType: creditCard.cardType,
                    nameOnCard: creditCard.nameOnCard,
                    cardNumber: "",
                    expDateMo: "",
                    expDateYr: "",
                    securityCode: "",
                });
            }

            if (data.eft) {
                const eft = data.eft;
                setBankInfoState({
                    ...bankInfoState,
                    accountType: eft.accountType,
                    nameOnAccount: eft.nameOnAccount,
                    routingNumber: eft.routingNumber,
                    accountNumber: "",
                    bankName: eft.bankName,
                });
            }

            if (data.billingAddress) {
                const billing = data.billingAddress;
                setAddressState({
                    ...addressState,
                    address1: billing.address1,
                    address2: billing.address2,
                    city: billing.city,
                    state: billing.state,
                    zipCode: billing.zipCode,
                    phone: billing.phone ? billing.phone : "",
                    country: billing.country,
                });
                setValue("phoneNumber", billing.phone ? billing.phone : "");
            } else {
                loadMyAccountInfo();
            }

            if (data.paymentMethod) {
                const paymentMethod = data.paymentMethod;
                setPaymentModeState({
                    ...paymentModeState,
                    name: paymentMethod.name,
                    selection: paymentMethod.selection,
                    options: paymentMethod.options,
                    subscriptionType: paymentMethod.subscriptionType,
                });
            }

            if (data.paymentMethod) {
                const paymentMethod = data.paymentMethod;
                setPaymentModeState({
                    ...paymentModeState,
                    name: paymentMethod.name,
                    selection: paymentMethod.selection,
                    options: paymentMethod.options,
                    subscriptionType: paymentMethod.subscriptionType,
                });
            }

            setBillingText(data.customMessage);

            let hasBillingInfo = data?.billingAddress?.address1 || data?.creditCard?.nameOnCard || data?.eft?.nameOnAccount;
            setBillingOperation(hasBillingInfo ? "Update " : "Add ");

            if (!hasBillingInfo) {
                let foundItem = data?.paymentMethod?.options?.find((it: string) => it.toUpperCase() === "CC");
                if (foundItem) {
                    setSelectedPaymentOption("CC");
                }
            }
        });
    }, []);

    const loadMyAccountInfo = () => {
        setLoading(true);
        services.GetAccountInformation().then((accountInfoResponse) => {
            setLoading(false);
            if (accountInfoResponse.isSuccess && accountInfoResponse._unifiedAccountInfo) {
                const accountInfo = accountInfoResponse._unifiedAccountInfo;
                setAddressState({
                    ...addressState,
                    address1: accountInfo.address1!,
                    address2: accountInfo.address2!,
                    city: accountInfo.city!,
                    state: { options: [], selection: accountInfo.state!, readOnly: true },
                    zipCode: accountInfo.zipCode!,
                    phone: accountInfo.phone ? accountInfo.phone : "",
                    country: accountInfo.country!,
                });
            }
        });
    };

    const selectedCardType = () => {
        const cardType = cardInfoState?.cardType?.selection;
        if (cardType) {
            const cardTypeObject = cardBrandList.find((card) => card.name === cardType || card.value === cardType);
            if (cardTypeObject) {
                return cardTypeObject.value;
            }
        }
        return "";
    };

    const validateSecurityCode = {
        invalid: (val: any) => {
            if (cardInfoState.cardType?.selection === "AMEX") {
                return /^$|^(\d{4})$/.test(val);
            }
            return /^$|^(\d{3})$/.test(val);
        },
    };

    const escapeHtml = (dycript: any) => {
        return dycript.replace(/&amp;/g, "&");
    };

    useEffect(() => {
        const elements = document.getElementsByClassName("PhoneInputCountry");

        if (elements && elements.length > 0) {
            try {
                for (const el of elements) {
                    const childs = el.children;
                    if (childs[0].nodeName === "SELECT") {
                        const selectEl = childs[0] as HTMLSelectElement;
                        selectEl.disabled = true;
                    }
                }
            } catch { }
        }
    }, []);

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="coins" />
                </div>
                <h1>
                    {billingOperation} {tLang("manageAccount.protectionPlan.billingInformation.title")}
                </h1>
                <BillingSecurityNote />
                {billingText && <p className="status-bad">{parse(billingText)}</p>}
            </div>
            <form id="protection-plan-billing-form-container" onSubmit={handleSubmit(submitBillingInfo)}>
                <div id="billing-info-dialog" className={loading ? "loading dialog-body large-dialog-scroll" : "dialog-body large-dialog-scroll"}>
                    <div className="form-row">
                        <fieldset className="form-row inline">
                            <div className="row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <legend className="legend-label">
                                        {" "}
                                        <label className="form-radio-label" htmlFor="payment_method_billingType_credit">
                                            {tLang("manageAccount.protectionPlan.billingInformation.label.paymentMethod")}
                                        </label>
                                    </legend>
                                </div>

                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="row ">
                                        {isDisplayableSection("CC") && (
                                            <div className="col-xs-6 col-no-gutter">
                                                <div className="form-row row">
                                                    <label className="form-radio-label" htmlFor="payment_method_billingType_credit">
                                                        <input
                                                            type="radio"
                                                            id="payment_method_billingType_credit"
                                                            name="payment_method_billingType"
                                                            value="CC"
                                                            onChange={(e) => {
                                                                handlePaymentMethodChange(e);
                                                                clearErrors("billingAddress");
                                                            }}
                                                            checked={selectedPaymentOption === "CC"}
                                                        />
                                                        <span className="form-radio-label-text">
                                                            {tLang("manageAccount.protectionPlan.billingInformation.label.creditCard")}
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        )}

                                        {isDisplayableSection("EFT") && (
                                            <div className="col-xs-6 col-no-gutter">
                                                <div className="form-row row">
                                                    <label className="form-radio-label" htmlFor="payment_method_billingType_eft">
                                                        <input
                                                            type="radio"
                                                            id="payment_method_billingType_eft"
                                                            name="payment_method_billingType"
                                                            value="EFT"
                                                            onChange={(e) => handlePaymentMethodChange(e)}
                                                            checked={selectedPaymentOption === "EFT"}
                                                        />
                                                        <span className="form-radio-label-text">
                                                            {tLang("manageAccount.protectionPlan.billingInformation.label.eft")}
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </fieldset>

                        {selectedPaymentOption === "CC" && isDisplayableSection("CC") && (
                            <React.Fragment>
                                <fieldset className="form-row">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">
                                                <label htmlFor="label-cardholder-name">
                                                    {" "}
                                                    {tLang("manageAccount.protectionPlan.billingInformation.label.cardholderName")}
                                                </label>
                                            </legend>
                                        </div>
                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={`form-row row ${errors["cardholderName"] && "status-error"}`}>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                ref={register({ required: true, pattern: PATTERNS.CARDHOLDERNAME.pattern, maxLength: 30 })}
                                                                className="inputbox"
                                                                id="label-cardholder-name"
                                                                defaultValue={cardInfoState.nameOnCard}
                                                                onChange={(e) => setCardInfoState({ ...cardInfoState, nameOnCard: e.target.value })}
                                                                placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.cardholderName")}
                                                                name="cardholderName"
                                                            />
                                                            {errors["cardholderName"] && errors["cardholderName"].type === "required" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.cardholderName.required")}
                                                                </span>
                                                            )}
                                                            {errors["cardholderName"] && errors["cardholderName"].type === "pattern" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.cardholderName.invalid")}
                                                                </span>
                                                            )}
                                                            {errors["cardholderName"] && errors["cardholderName"].type === "maxLength" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.cardholderName.maxLength")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">
                                                {" "}
                                                <label htmlFor="label-card-type">{tLang("manageAccount.protectionPlan.billingInformation.label.cardType")}</label>
                                            </legend>
                                        </div>
                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={`form-row row ${errors["cardType"] && "status-error"}`}>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <select
                                                                name="cardType"
                                                                className="inputbox"
                                                                id="label-card-type"
                                                                defaultValue={selectedCardType()}
                                                                ref={register({ required: true })}
                                                                onChange={(e) =>
                                                                    setCardInfoState({
                                                                        ...cardInfoState,
                                                                        cardType: { ...cardInfoState.cardType, selection: e.target.value },
                                                                    })
                                                                }
                                                            >
                                                                {/*<option value="">--</option>
                                                                {cardInfoState.cardType?.options.map((val: any) => (
                                                                    <option key={val} value={val}>{val}</option>
                                                                ))}*/}

                                                                {cardBrandList.map((val: any) => (
                                                                    <option key={val.value} value={val.value}>
                                                                        {val.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors["cardType"] && errors["cardType"].type === "required" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.cardType.required")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="form-row">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">
                                                {" "}
                                                <label htmlFor="label-card-number">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.label.cardNumber")}
                                                </label>
                                            </legend>
                                        </div>
                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={`form-row row ${errors["cardNumber"] && "status-error"}`}>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                ref={register({ required: true, pattern: /^$|^(\d{15,16})$/ })}
                                                                className="inputbox"
                                                                id="label-card-number"
                                                                defaultValue=""
                                                                onChange={(e) => setCardInfoState({ ...cardInfoState, cardNumber: e.target.value })}
                                                                placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.cardNumber")}
                                                                name="cardNumber"
                                                                maxLength={16}
                                                            />
                                                            {errors["cardNumber"] && errors["cardNumber"].type === "required" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.cardNumber.required")}
                                                                </span>
                                                            )}
                                                            {errors["cardNumber"] && errors["cardNumber"].type === "pattern" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.cardNumber.pattern")}
                                                                </span>
                                                            )}
                                                            {errors["cardNumber"] && errors["cardNumber"].type === "validate" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.cardNumber.invalid")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="form-row">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">
                                                <label htmlFor="expirationDate">
                                                    {" "}
                                                    {tLang("manageAccount.protectionPlan.billingInformation.label.expirationDate")}{" "}
                                                </label>
                                            </legend>
                                        </div>
                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={`form-row row ${errors["expirationDate"] && "status-error"}`}>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                name="expirationDate"
                                                                id="expirationDate"
                                                                type="text"
                                                                onKeyDown={keyCode}
                                                                onChange={addMask}
                                                                className="inputbox"
                                                                ref={register({
                                                                    required: true,
                                                                    maxLength: 5,
                                                                    pattern: /(0[1-9]|1[012])[/]?([0-9][1-9]|[1-9][0-9])/,
                                                                    validate: (value) => {
                                                                        if (value.length === 5) {
                                                                            const expireDate = value.split("/");
                                                                            return validateCardExpiry(expireDate[0], expireDate[1]);
                                                                        }
                                                                        return true;
                                                                    },
                                                                })}
                                                                placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.expirationDate")}
                                                                maxLength={5}
                                                            />
                                                            {errors["expirationDate"] && errors["expirationDate"].type === "required" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.expirationDate.required")}
                                                                </span>
                                                            )}
                                                            {errors["expirationDate"] && errors["expirationDate"].type === "pattern" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.expirationDate.pattern")}
                                                                </span>
                                                            )}
                                                            {errors["expirationDate"] && errors["expirationDate"].type === "validate" && (
                                                                <span className="form-error">{`${tLang(
                                                                    "manageAccount.protectionPlan.billingInformation.validation.expirationDate.invalid"
                                                                )} ${partnerPhoneNumber}.`}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="form-row">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">
                                                <label htmlFor="label-security-code">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.label.securityCode")}
                                                </label>
                                            </legend>
                                        </div>
                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={`form-row row ${errors["securityCode"] && "status-error"}`}>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                type="password"
                                                                maxLength={cardInfoState.cardType?.selection === "AMEX" ? 4 : 3}
                                                                ref={register({ required: true, validate: validateSecurityCode })}
                                                                className="inputbox"
                                                                id="label-security-code"
                                                                defaultValue={cardInfoState.securityCode}
                                                                onChange={(e) => setCardInfoState({ ...cardInfoState, securityCode: e.target.value })}
                                                                placeholder="CVV"
                                                                name="securityCode"
                                                            />
                                                            {errors["securityCode"] && errors["securityCode"].type === "required" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.securityCode.required")}
                                                                </span>
                                                            )}
                                                            {errors["securityCode"] && errors["securityCode"].type === "invalid" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.securityCode.invalid")}{" "}
                                                                    {cardInfoState.cardType?.selection === "AMEX" ? "4" : "3"}{" "}
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.securityCode.digit")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </React.Fragment>
                        )}

                        {selectedPaymentOption === "EFT" && isDisplayableSection("EFT") && (
                            <React.Fragment>
                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">
                                                <label htmlFor="label-account-name">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.label.nameOnAccount")}
                                                </label>
                                            </legend>
                                        </div>
                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={`form-row row ${errors["accountName"] && "status-error"}`}>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                name="accountName"
                                                                className="inputbox"
                                                                id="label-account-name"
                                                                placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.nameOnAccount")}
                                                                defaultValue={bankInfoState.nameOnAccount}
                                                                ref={register({ required: true, pattern: /^[a-zA-Z-'\s.]+$/, maxLength: 30 })}
                                                                onChange={(e) => setBankInfoState({ ...bankInfoState, nameOnAccount: e.target.value })}
                                                            />
                                                            {errors["accountName"] && errors["accountName"].type === "required" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.nameOnAccount.required")}
                                                                </span>
                                                            )}
                                                            {errors["accountName"] && errors["accountName"].type === "pattern" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.nameOnAccount.pattern")}
                                                                </span>
                                                            )}
                                                            {errors["accountName"] && errors["accountName"].type === "maxLength" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.nameOnAccount.maxLength")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">
                                                <label htmlFor="label-bank-name">{tLang("manageAccount.protectionPlan.billingInformation.label.bankName")}</label>
                                            </legend>
                                        </div>
                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={`form-row row ${errors["bankName"] && "status-error"}`}>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            {bankInfoState.bankName?.options?.length > 0 ? (
                                                                <React.Fragment>
                                                                    <input
                                                                        type="text"
                                                                        name="bankName"
                                                                        className="inputbox"
                                                                        id="label-bank-name"
                                                                        placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.bankName")}
                                                                        defaultValue={escapeHtml(bankInfoState.bankName?.selection)}
                                                                        ref={register({ required: true })}
                                                                        readOnly={true}
                                                                    />
                                                                </React.Fragment>
                                                            ) : (
                                                                <React.Fragment>
                                                                    <input
                                                                        type="text"
                                                                        name="bankName"
                                                                        className="inputbox"
                                                                        id="label-bank-name"
                                                                        placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.bankName")}
                                                                        defaultValue={bankInfoState.bankName?.selection}
                                                                        ref={register({ required: true })}
                                                                        onChange={(e) =>
                                                                            setBankInfoState({
                                                                                ...bankInfoState,
                                                                                bankName: { ...bankInfoState.bankName, selection: e.target.value },
                                                                            })
                                                                        }
                                                                    />
                                                                </React.Fragment>
                                                            )}
                                                            {errors["bankName"] && errors["bankName"].type === "required" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.bankName.required")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">
                                                <label htmlFor="label-routing-number">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.label.routingNumber")}
                                                </label>
                                            </legend>
                                        </div>
                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={`form-row row ${errors["routingNumber"] && "status-error"}`}>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            {bankInfoState.routingNumber?.options?.length > 0 ? (
                                                                <React.Fragment>
                                                                    <select
                                                                        name="routingNumber"
                                                                        className="inputbox"
                                                                        id="label-routing-number"
                                                                        defaultValue={bankInfoState.routingNumber?.selection}
                                                                        ref={register({ required: true, pattern: /^(\d{9})|$^[0-9]*$/ })}
                                                                        onChange={(e) =>
                                                                            setBankInfoState({
                                                                                ...bankInfoState,
                                                                                routingNumber: { ...bankInfoState.routingNumber, selection: e.target.value },
                                                                            })
                                                                        }
                                                                    >
                                                                        <option value="">--</option>
                                                                        {bankInfoState.routingNumber?.options.map((val: any) => (
                                                                            <option key={val} value={val}>
                                                                                {val}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </React.Fragment>
                                                            ) : (
                                                                <React.Fragment>
                                                                    <input
                                                                        type="text"
                                                                        name="routingNumber"
                                                                        className="inputbox"
                                                                        id="label-routing-number"
                                                                        placeholder={tLang(
                                                                            "manageAccount.protectionPlan.billingInformation.placeholder.routingNumber"
                                                                        )}
                                                                        defaultValue={bankInfoState.routingNumber?.selection}
                                                                        ref={register({ required: true, pattern: /^(\d{9})|$^[0-9]*$/ })}
                                                                        maxLength={9}
                                                                        onChange={(e) =>
                                                                            setBankInfoState({
                                                                                ...bankInfoState,
                                                                                routingNumber: { ...bankInfoState.routingNumber, selection: e.target.value },
                                                                            })
                                                                        }
                                                                    />
                                                                </React.Fragment>
                                                            )}
                                                            {errors["routingNumber"] && errors["routingNumber"].type === "required" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.routingNumber.required")}
                                                                </span>
                                                            )}
                                                            {errors["routingNumber"] && errors["routingNumber"].type === "pattern" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.routingNumber.pattern")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">
                                                <label htmlFor="label-account-number">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.label.accountNumber")}
                                                </label>
                                            </legend>
                                        </div>
                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={`form-row row ${errors["accountNumber"] && "status-error"}`}>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                name="accountNumber"
                                                                className="inputbox"
                                                                id="label-account-number"
                                                                placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.accountNumber")}
                                                                defaultValue={bankInfoState.accountNumber}
                                                                ref={register({ required: true, pattern: /^$|^(\d{5,17})$/ })}
                                                                maxLength={17}
                                                                onChange={(e) => setBankInfoState({ ...bankInfoState, accountNumber: e.target.value })}
                                                            />
                                                            {errors["accountNumber"] && errors["accountNumber"].type === "required" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.accountNumber.required")}
                                                                </span>
                                                            )}
                                                            {errors["accountNumber"] && errors["accountNumber"].type === "pattern" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.accountNumber.pattern")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className={`form-row inline row}`}>
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <legend className="legend-label">
                                                    <label htmlFor="label-account-type">
                                                        {" "}
                                                        {tLang("manageAccount.protectionPlan.billingInformation.label.accountType")}
                                                    </label>
                                                </legend>
                                            </div>
                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div className="row">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <div className={`form-row row ${errors["accountType"] && "status-error"}`}>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                {paymentModeState?.options?.length === 1 && paymentModeState?.selection === "EFT" ? (
                                                                    <React.Fragment>
                                                                        <input
                                                                            type="text"
                                                                            name="accountType"
                                                                            className="inputbox"
                                                                            id="label-account-type"
                                                                            placeholder={tLang(
                                                                                "manageAccount.protectionPlan.billingInformation.placeholder.accountType"
                                                                            )}
                                                                            defaultValue={bankInfoState.accountType?.selection}
                                                                            ref={register({ required: true })}
                                                                            readOnly={true}
                                                                        />
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <React.Fragment>
                                                                        <select
                                                                            name="accountType"
                                                                            className="inputbox"
                                                                            id="label-account-type"
                                                                            defaultValue={bankInfoState.accountType?.selection}
                                                                            disabled={
                                                                                paymentModeState?.options?.length === 1 && paymentModeState?.selection === "EFT"
                                                                            }
                                                                            ref={register({ required: true })}
                                                                            onChange={(e) =>
                                                                                setBankInfoState({
                                                                                    ...bankInfoState,
                                                                                    accountType: { ...bankInfoState.accountType, selection: e.target.value },
                                                                                })
                                                                            }
                                                                        >
                                                                            <option value="">---</option>
                                                                            {bankInfoState.accountType?.options.map((val: any) => (
                                                                                <option key={val} value={val}>
                                                                                    {val}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </React.Fragment>
                                                                )}
                                                                {errors["accountType"] && errors["accountType"].type === "required" && (
                                                                    <span className="form-error">
                                                                        {tLang("manageAccount.protectionPlan.billingInformation.validation.accountType.required")}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                                <div className="form-row">
                                    <div className="form-input">
                                        <label className="form-checkbox-label" htmlFor="isEFTChecked">
                                            <input
                                                type="checkbox"
                                                id="isEFTChecked"
                                                name="isEFTChecked"
                                                ref={register({ required: true })}
                                                onChange={() => checked()}
                                            />
                                            <span className="form-checkbox-label-text">
                                                {tLang("manageAccount.protectionPlan.billingInformation.validation.I")}
                                                <span
                                                    className="default_link"
                                                    role="button"
                                                    tabIndex={0}
                                                    onKeyDown={(e) => {
                                                        setEFTDialog(true);
                                                        window.addToDataLayer({ event: "Protection Plan - EFT Acknowledgement" });
                                                    }}
                                                    onClick={() => {
                                                        setEFTDialog(true);
                                                        window.addToDataLayer({ event: "Protection Plan - EFT Acknowledgement" });
                                                    }}
                                                >
                                                    &nbsp;
                                                    <a href="/#" className="default_link" onClick={(e) => e.preventDefault()}>
                                                        {tLang("manageAccount.protectionPlan.billingInformation.validation.authorize")}
                                                    </a>
                                                    &nbsp;
                                                </span>
                                                {tLang("manageAccount.protectionPlan.billingInformation.validation.bankInfo")}
                                            </span>

                                            {errors["isEFTChecked"] && errors["isEFTChecked"].type === "required" && (
                                                <span className="form-error">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.checkAuthRequired")}
                                                </span>
                                            )}
                                        </label>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                    <div className="line-divider margin-vertical-l"></div>
                    <div className="form-row">
                        <div className="dialog-icon">
                            <h3>
                                <RenderIcons iconName="map-marker" /> {tLang("manageAccount.protectionPlan.billingInformation.label.billingAddress")}
                            </h3>
                        </div>
                        <div className="margin-vertical-xs"></div>
                        <React.Fragment>
                            <fieldset className="form-row inline">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <legend className="legend-label">
                                            <label htmlFor="label-address-line-1">{tLang("manageAccount.protectionPlan.billingInformation.label.street")}</label>
                                        </legend>
                                    </div>

                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className={`form-row row ${errors["address1"] && "status-error"}`}>
                                            <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                <label htmlFor="label-address-line1">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.label.addressLine1")}
                                                </label>
                                            </div>
                                            <div className="form-input col-xs-12 col-no-gutter">
                                                <input
                                                    type="text"
                                                    name="address1"
                                                    className="inputbox"
                                                    defaultValue={addressState.address1}
                                                    onChange={(e) => {
                                                        setAddressState({ ...addressState, address1: e.target.value });
                                                        clearErrors("billingAddress");
                                                    }}
                                                    id="label-address-line-1"
                                                    ref={register({
                                                        required: true,
                                                        pattern: PATTERNS.STREETADDRESS.pattern,
                                                    })}
                                                    placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.addressLine1")}
                                                />
                                                {errors["address1"] && errors["address1"].type === "required" && (
                                                    <span className="form-error">
                                                        {tLang("manageAccount.protectionPlan.billingInformation.validation.address1.required")}
                                                    </span>
                                                )}
                                                {errors["address1"] && errors["address1"].type === "pattern" && (
                                                    <span className="form-error">
                                                        {tLang("manageAccount.protectionPlan.billingInformation.validation.address1.pattern")}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className={`form-row row ${errors["address2"] && "status-error"}`}>
                                            <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                <label htmlFor="label-address-line-2">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.label.addressLine2")}
                                                </label>
                                            </div>
                                            <div className="form-input col-xs-12 col-no-gutter">
                                                <input
                                                    type="text"
                                                    name="address2"
                                                    className="inputbox"
                                                    defaultValue={addressState.address2}
                                                    onChange={(e) => {
                                                        setAddressState({ ...addressState, address2: e.target.value });
                                                        clearErrors("billingAddress");
                                                    }}
                                                    id="label-address-line-2"
                                                    ref={register({
                                                        pattern: PATTERNS.STREETADDRESS.pattern,
                                                    })}
                                                    placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.addressLine2")}
                                                />
                                                {errors["address2"] && errors["address2"].type === "pattern" && (
                                                    <span className="form-error">
                                                        {tLang("manageAccount.protectionPlan.billingInformation.validation.address2.pattern")}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset className="form-row inline">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <legend className="legend-label">
                                            {" "}
                                            <label htmlFor="label-address-city">{tLang("manageAccount.protectionPlan.billingInformation.label.city")}</label>
                                        </legend>
                                    </div>

                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="row">
                                            <div className="col-xs-12 col-no-gutter">
                                                <div className={`form-row row ${errors["city"] && "status-error"}`}>
                                                    <div className="form-input col-xs-12 col-no-gutter">
                                                        <input
                                                            type="text"
                                                            name="city"
                                                            className="inputbox"
                                                            defaultValue={addressState.city}
                                                            onChange={(e) => {
                                                                setAddressState({ ...addressState, city: e.target.value });
                                                                clearErrors("billingAddress");
                                                            }}
                                                            id="label-address-city"
                                                            ref={register({ required: true, pattern: PATTERNS.CITY.pattern })}
                                                            placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.city")}
                                                        />
                                                        {errors["city"] && errors["city"].type === "required" && (
                                                            <span className="form-error">
                                                                {tLang("manageAccount.protectionPlan.billingInformation.validation.city.required")}
                                                            </span>
                                                        )}
                                                        {errors["city"] && errors["city"].type === "pattern" && (
                                                            <span className="form-error">
                                                                {tLang("manageAccount.protectionPlan.billingInformation.validation.city.pattern")}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset className="form-row inline">

                                {accountInfo?.country !== null && accountInfo?.country === "CA" ? (
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">
                                                {" "}
                                                <label htmlFor="label-address-state">Province</label>
                                            </legend>
                                        </div>

                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={`form-row row ${errors["state"] && "status-error"}`}>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <select
                                                                name="state"
                                                                className="inputbox"
                                                                id="label-address-state"
                                                                value={addressState.state?.selection}
                                                                ref={register({ required: true, pattern: /^[a-zA-Z.\s]+$/ })}
                                                                onChange={(e) => {
                                                                    setAddressState({
                                                                        ...addressState,
                                                                        state: { ...addressState.state, selection: e.target.value },
                                                                    });
                                                                    clearErrors("billingAddress");
                                                                }}
                                                            >
                                                                {CAProvinces.map((val: any) => (
                                                                    <option key={val.name} value={val.value}>
                                                                        {val.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors["state"] && (errors["state"].type === "required" || errors["state"].type === "pattern") && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.province.required")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                ) : (
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">
                                                {" "}
                                                <label htmlFor="label-address-state">{tLang("manageAccount.protectionPlan.billingInformation.label.state")}</label>
                                            </legend>
                                        </div>

                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={`form-row row ${errors["state"] && "status-error"}`}>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <select
                                                                name="state"
                                                                className="inputbox"
                                                                id="label-address-state"
                                                                value={addressState.state?.selection}
                                                                ref={register({ required: true, pattern: /^[a-zA-Z.\s]+$/ })}
                                                                onChange={(e) => {
                                                                    setAddressState({
                                                                        ...addressState,
                                                                        state: { ...addressState.state, selection: e.target.value },
                                                                    });
                                                                    clearErrors("billingAddress");
                                                                }}
                                                            >
                                                                {stateList.map((val: any) => (
                                                                    <option key={val.name} value={val.value}>
                                                                        {val.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors["state"] && (errors["state"].type === "required" || errors["state"].type === "pattern") && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.state.required")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </fieldset>

                            <fieldset className="form-row inline">
                                {accountInfo?.country !== null && accountInfo?.country === "CA" ? (
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">
                                                {" "}
                                                <label htmlFor="label-address-zipcode">Postal Code</label>
                                            </legend>
                                        </div>

                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={`form-row row ${errors["zipcode"] && "status-error"}`}>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                name="zipcode"
                                                                className="inputbox"
                                                                onChange={(e) => {
                                                                    setAddressState({ ...addressState, zipCode: e.target.value });
                                                                    clearErrors("billingAddress");
                                                                }}
                                                                defaultValue={addressState.zipCode}
                                                                id="label-address-zipcode"
                                                                ref={register({ required: true, pattern: PATTERNS.POSTALCODE.pattern })}
                                                                placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.postalCode")}
                                                            />
                                                            {errors["zipcode"] && errors["zipcode"].type === "required" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.postalCode.required")}
                                                                </span>
                                                            )}
                                                            {errors["zipcode"] && errors["zipcode"].type === "pattern" && (
                                                                <span className="form-error">
                                                                    "Please Enter a Valid Postal Code"
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">
                                                {" "}
                                                <label htmlFor="label-address-zipcode">{zipCode.Label}</label>
                                            </legend>
                                        </div>

                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={`form-row row ${errors["zipcode"] && "status-error"}`}>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                name="zipcode"
                                                                className="inputbox"
                                                                onChange={(e) => {
                                                                    setAddressState({ ...addressState, zipCode: e.target.value });
                                                                    clearErrors("billingAddress");
                                                                }}
                                                                defaultValue={addressState.zipCode}
                                                                id="label-address-zipcode"
                                                                ref={register({ required: true, pattern: PATTERNS.ZIPCODE.pattern })}
                                                                placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.zipCode")}
                                                            />
                                                            {errors["zipcode"] && errors["zipcode"].type === "required" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.zipCode.required")}
                                                                </span>
                                                            )}
                                                            {errors["zipcode"] && errors["zipcode"].type === "pattern" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.zipCode.pattern")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </fieldset>

                            <fieldset className="form-row inline">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <legend className="legend-label">
                                            <label htmlFor={"label-address-phone-number"}>
                                                {tLang("manageAccount.protectionPlan.billingInformation.label.phoneNumber")}{" "}
                                            </label>
                                        </legend>
                                    </div>

                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="row">
                                            <div className="col-xs-12 col-no-gutter">
                                                <div className={`form-row row ${errors["phoneNumber"] && "status-error"}`}>
                                                    <div className="form-input col-xs-12 col-no-gutter">
                                                        {addressState && (
                                                            <>
                                                                <Controller
                                                                    name={`phoneNumber`}
                                                                    control={control}
                                                                    onFocus={() => {
                                                                        if (phoneInputRef?.current) {
                                                                            phoneInputRef.current?.focus();
                                                                        }
                                                                    }}
                                                                    defaultValue={addressState.phone ? addressState.phone : ""}
                                                                    className="inputbox"
                                                                    rules={{
                                                                        required: true,
                                                                        validate: (value) =>
                                                                            value
                                                                                ? isValidPhoneNo(
                                                                                    accountInfo && accountInfo.country ? accountInfo.country : "US",
                                                                                    value
                                                                                )
                                                                                : false,
                                                                    }}
                                                                    onChange={(e: any) => {
                                                                        updatePhoneNumber(e);
                                                                        clearErrors("billingAddress");
                                                                    }}
                                                                    render={({ onChange, value, ref }) => {
                                                                        phoneInputRef = ref;

                                                                        return (
                                                                            <PhoneInput
                                                                                ref={ref}
                                                                                value={value}
                                                                                onChange={onChange}
                                                                                international={false}
                                                                                addInternationalOption={false}
                                                                                className="inputbox"
                                                                                defaultCountry={accountInfo && accountInfo.country ? accountInfo.country : "US"}
                                                                                countries={[accountInfo && accountInfo.country ? accountInfo.country : "US"]}
                                                                                id={"label-address-phone-number"}
                                                                                placeholder={tLang(
                                                                                    "manageAccount.protectionPlan.billingInformation.placeholder.phoneNumber"
                                                                                )}
                                                                                maxLength={15}
                                                                                minLength={10}
                                                                            />
                                                                        );
                                                                    }}
                                                                />
                                                                {errors["phoneNumber"] && errors["phoneNumber"].type === "required" && (
                                                                    <span className="form-error">
                                                                        {tLang("manageAccount.protectionPlan.billingInformation.validation.phone.required")}
                                                                    </span>
                                                                )}
                                                                {errors["phoneNumber"] && errors["phoneNumber"].type === "validate" && (
                                                                    <span className="form-error">
                                                                        {tLang("manageAccount.protectionPlan.billingInformation.validation.phone.validate")}
                                                                    </span>
                                                                )}
                                                                {errors["phoneNumber"] && errors["phoneNumber"].type === "minLength" && (
                                                                    <span className="form-error">
                                                                        {tLang("manageAccount.protectionPlan.billingInformation.validation.phone.minLength")}
                                                                    </span>
                                                                )}
                                                                {errors["phoneNumber"] && errors["phoneNumber"].type === "maxLength" && (
                                                                    <span className="form-error">
                                                                        {tLang("manageAccount.protectionPlan.billingInformation.validation.phone.minLength")}
                                                                    </span>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            {errors["billingAddress"] && (
                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter"></div>
                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <span className="form-error">{tLang("manageAccount.protectionPlan.billingInformation.validation.invalidAddress")}</span>
                                        </div>
                                    </div>
                                </fieldset>
                            )}
                        </React.Fragment>
                    </div>
                </div>
                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                type="button"
                                className="btn-default btn-link btn-no-padding btn-no-border"
                                id="btn-cancel-protection-plan-billing"
                                onClick={() => {
                                    window.addToDataLayer({ event: "Protection Plan - Close billing info" });
                                    RefreshAndClose();
                                }}
                            >
                                <span className="btn-text">{tLang("manageAccount.protectionPlan.billingInformation.btn.cancel")}</span>
                            </button>
                        </div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                type="submit"
                                className="btn-default btn-primary"
                                id="btn-submit-update-billing"
                                disabled={loading}
                                onClick={() => window.addToDataLayer({ event: "Protection Plan - Submit Billing Info" })}
                            >
                                <span className="btn-text">
                                    {billingOperation} {tLang("manageAccount.protectionPlan.billingInformation.btn.billing")}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            {EFTdialog && (
                <DialogComponent dialogId="whatsIncluded" hideCloseButton={true} title="Your cart" closeDialog={handleCloseEFTDialog}>
                    <EFTDialog data={state.EFTData} closeDialog={handleCloseEFTDialog}></EFTDialog>
                </DialogComponent>
            )}
        </React.Fragment>
    );
};
export default ProtectionPlanBillingInfo;
